import { observable } from "mobx";
import { NextRacesLine } from "../NextRacesLine";

export type NextRacesEventType = {
    id:string;
    date: Date;
    rows: NextRacesLine[];
    url: string;
    hasLiveStream: boolean;
    leagueName: string;
    handler: Function;
}

/**
 * NextRacesEvent model for visualization of Next Races block
 *
 * @typedef NextRacesEvent
 * @type {Object}
 * @property {id} Unique identifier
 * @property {row} Array of NextRacesLine
 * @property {title}  Header text of next races
 * @property {hasLiveStream} Flag for showing livesteaming icon
 * @property {url} Url path to event view
 * @property {handler} Function for navigation to event view
 */
export class NextRacesEvent {
    id: string;
    url: string;
    title: string;
    handler: Function;
    @observable rows: NextRacesLine[];
    @observable hasLiveStream: boolean;

    constructor(source: NextRacesEventType) {
        this.id = source.id;
        this.rows = source.rows;
        this.url = source.url;
        this.hasLiveStream = source.hasLiveStream;
        this.title = `${source.date.formatDate("HH:mm")} ${source.leagueName}`;
        this.handler = source.handler;
    }
}